import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warnings that are triggered by
// embedded HubSpot forms and other iframe-based widgets. We wrap the
// ResizeObserver constructor so that its callback never propagates these
// specific loop warnings to window.onerror / CRA's dev error overlay.
if (typeof window !== "undefined" && typeof window.ResizeObserver !== "undefined") {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (err) {
            if (
              err &&
              typeof err.message === "string" &&
              err.message.includes("ResizeObserver loop")
            ) {
              return;
            }
            throw err;
          }
        });
      });
    }
  };
}

const resizeObserverLoopErrRe = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications\.?)$/;
window.addEventListener(
  "error",
  (e) => {
    if (e && e.message && resizeObserverLoopErrRe.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
